import axios from 'axios';
import { HOST } from '../../configs/constants';
import * as Actions from '../../modules/account/login/actions/authAction';
import { getAccessToken } from '../account/login/service/jwtTokenUtil';
import { store } from './../../redux/storeConfig/store';
import { GLOBAL_LOADED, GLOBAL_LOADING } from '../../redux/reducers/loading';

// import { createJWTToken, getToken } from './authenticationUtils';
// import { logout } from '../utils/authenticationUtils';

const clientInstance = axios.create({
  // TODO 추후 proxy 설정 풀고 서버측 cross-origin 해제(security로 가능)
  baseURL: HOST
});

clientInstance.interceptors.request.use(
  async config => {
    let accessToken = await getAccessToken();

    config.headers['Authorization'] = accessToken;
    // alert(JSON.stringify(config.headers));
    store.dispatch({
      type: GLOBAL_LOADING
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

clientInstance.interceptors.response.use(
  response => {
    // if (response.data.errCode < 0) {
    //   alert('서버 처리중 오류가 발생하였습니다.');
    // }
    store.dispatch({
      type: GLOBAL_LOADED
    });
    return response.data;
  },
  error => {
    const message = error?.message || '';

    const name = error?.name || '';

    if (error?.response?.status == 401) {
      // alert('인증정보가 없습니다. 다시 로그인해 주세요.');
      // window.location.href = '/account/login';
      store.dispatch(Actions.logout.request());
    } else {
    }

    return Promise.reject(error);
  }
);

// clientInstance.CancelToken = axios.CancelToken;

export default clientInstance;
